import React, { Component, forwardRef } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
} from 'semantic-ui-react';

import Validate from './Validate';

class Input extends Component {
  static propTypes = {
    autoComplete: PropTypes.string,
    message: PropTypes.string,
    disabled: PropTypes.bool,
    hideMessage: PropTypes.bool,
    id: PropTypes.string, // lets a shorthand label ({ children, htmlFor }) point at the input
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
      PropTypes.object, // Semantic's label shorthand, e.g. { children, htmlFor }
    ]),
    loading: PropTypes.bool,
    min: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    type: PropTypes.string,
    step: PropTypes.string,
    icon: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string,
      PropTypes.node,
    ]),
    pattern: PropTypes.string,
    style: PropTypes.oneOfType([
      PropTypes.object,
    ]),
    validation: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({
          validate: PropTypes.func,
          option: PropTypes.object,
        }),
      ]).isRequired,
    ),
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    showThousandSeparator: PropTypes.bool,
    validateName: PropTypes.string,
    validateLabel: PropTypes.string,
    validateRef: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({}),
    ]),
  }
  static defaultProps = {
    step: null,
  }

  constructor(props) {
    super(props);
    if (this.props.showThousandSeparator) {
      const formattedValue = this.addThousandSeparator(props.value);
      this.state = {
        formattedValue,
      };
    }
  }

  addThousandSeparator = (value) => {
    // remove any existing commas/ alphabets from the input
    const sanitizedValue = value ? value.replace(/[^\d.]/g, '') : '';
    // split the cents
    const splitValue = sanitizedValue.split('.');
    const amount = splitValue[0];
    let cents = splitValue[1] || '';
    if (cents.length > 2) {
      cents = cents.substring(0, 2);
    }
    // format the amount with commas
    const formattedValue = amount ? parseFloat(amount).toLocaleString() : '';

    // then combine the amount with the cents
    this.setState({
      formattedValue: value.includes('.') ? `${formattedValue}.${cents}` : formattedValue,
    });
    // return value without commas
    return amount && value.includes('.') ? `${amount}.${cents}` : amount;
  }

  handleOnChange = (e, data) => {
    if (this.props.showThousandSeparator) {
      data.value = this.addThousandSeparator(data.value);
    }
    // bubble up onChange
    if (this.props.onChange) {
      this.props.onChange(e, data);
    }
  }

  render() {
    const type = this.props.showThousandSeparator ? 'text' : this.props.type;
    const value = this.props.showThousandSeparator ? this.state.formattedValue : this.props.value;
    return (
      <Validate
        hideMessage={this.props.hideMessage}
        message={this.props.message}
        showThousandSeparator={this.props.showThousandSeparator}
        validation={this.props.validation}
        label={this.props.validateLabel || this.props.label}
        name={this.props.validateName || this.props.name}
        ref={this.props.validateRef}
        onChange={this.handleOnChange}
        style={this.props.style && this.props.style}
      >
        <Form.Input
          autoComplete={this.props.autoComplete}
          disabled={this.props.disabled}
          fluid
          id={this.props.id}
          label={this.props.label}
          loading={this.props.loading}
          name={this.props.name}
          placeholder={this.props.placeholder}
          readOnly={this.props.readOnly}
          type={type}
          pattern={this.props.pattern}
          value={value}
          step={this.props.step}
          min={this.props.min}
          icon={this.props.icon}
        />
      </Validate>
    );
  }
}

export default forwardRef((props, ref) => <Input {...props} validateRef={ref} />);



// WEBPACK FOOTER //
// ./src/components/AppForm/Input.jsx